<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <v-icon>
        mdi-clipboard-text-outline
      </v-icon>
      Schedule Interview
    </SecondaryButton>
    <ScheduleInterviewDialog
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import ScheduleInterviewDialog from "@/views/bookings/BookingInterviews/components/dialogs/ScheduleInterview/ScheduleInterviewDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "ScheduleInterviewAction",
  components: {
    ScheduleInterviewDialog,
    SecondaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
